// landing-carousel.js - controls the landing carousel behavior
(function() {
    // find all sections (supports multiple instances)
    document.querySelectorAll('[id^="landing-carousel-"]').forEach(section => {
      const track = section.querySelector('.carousel__track');
      if (!track) return;
      const slides = Array.from(track.children);
      // clone first & last slides for infinite loop
      const firstClone = slides[0].cloneNode(true);
      track.appendChild(firstClone);

      // update slides array to include clones
      const allSlides = Array.from(track.children);
      const dots = Array.from(section.querySelectorAll('.carousel__dot'));
  
      const autoplay = (section.dataset.autoplay === 'true' || section.dataset.autoplay === 'True');
      const interval = parseInt(section.dataset.interval, 10) || 5000;
      const transitionMs = parseInt(section.dataset.transition, 10) || 300;
      const pauseOnHover = (section.dataset.pauseOnHover === 'true' || section.dataset.pauseOnHover === 'True');
  
      let currentIndex = 1;
      let autoplayTimer = null;
      let isHovering = false;
      let isInteracting = false;
  
      // guard: if 0 or 1 slides, no autoplay needed but still show single slide
      if (slides.length === 0) return;
  
      // move to slide
      function goTo(index, animate = true) {
        track.style.transition = animate ? `transform ${transitionMs}ms ease` : 'none';
        track.style.transform = `translateX(-${index * 100}%)`;
        currentIndex = index;
      
        // handle wrap-around after transition (infinite loop)
        track.addEventListener('transitionend', () => {
          if (currentIndex === 0) {
            track.style.transition = 'none';
            currentIndex = slides.length; // real last slide
            track.style.transform = `translateX(-${currentIndex * 100}%)`;
          }
          if (currentIndex === slides.length + 1) {
            track.style.transition = 'none';
            currentIndex = 1; // real first slide
            track.style.transform = `translateX(-${currentIndex * 100}%)`;
          }
        }, { once: true });
      
        // update dots (only for real slides)
        dots.forEach((d, i) => {
          d.classList.toggle('is-active', i === currentIndex);
          d.setAttribute('aria-selected', i === currentIndex ? 'true' : 'false');
        });
      }
  
      function next() { goTo(currentIndex + 1, true); }
      function prev() { goTo(currentIndex - 1, true); }
  
      function startAutoplay() {
        if (!autoplay || slides.length <= 1) return;
        stopAutoplay();
        autoplayTimer = setInterval(() => {
          if (pauseOnHover && isHovering) return;
          if (isInteracting) return;
          next();
        }, interval);
      }
  
      function stopAutoplay() {
        if (autoplayTimer) {
          clearInterval(autoplayTimer);
          autoplayTimer = null;
        }
      }
  
      // events
      dots.forEach(dot => {
        dot.addEventListener('click', () => {
          const idx = parseInt(dot.dataset.index, 10);
          isInteracting = true;
          goTo(idx, true);
          setTimeout(()=> isInteracting=false, transitionMs+50);
        });
      });
  
      if (pauseOnHover) {
        section.addEventListener('mouseenter', () => { isHovering = true; });
        section.addEventListener('mouseleave', () => { isHovering = false; });
      }
  
      // simple touch/swipe support
      (function addSwipe(){
        let startX = 0;
        let deltaX = 0;
        const threshold = 40; // px
        track.addEventListener('touchstart', (e) => {
          startX = e.touches[0].clientX;
          deltaX = 0;
          isInteracting = true;
          stopAutoplay();
          track.style.transition = 'none';
        }, {passive: true});
        track.addEventListener('touchmove', (e) => {
          deltaX = e.touches[0].clientX - startX;
          track.style.transform = `translateX(-${currentIndex * 100 - (deltaX / track.clientWidth * 100)}%)`;
        }, {passive: true});
        track.addEventListener('touchend', (e) => {
          if (Math.abs(deltaX) > threshold) {
            if (deltaX < 0) next(); else prev();
          } else {
            goTo(currentIndex, true);
          }
          startAutoplay();
          isInteracting = false;
        });
      })();
  
      // keyboard nav
      section.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowLeft') prev();
        if (e.key === 'ArrowRight') next();
      });
  
      // init
      goTo(0, false);
      startAutoplay();
  
      // handle theme editor dynamic updates
      document.addEventListener('shopify:section:load', () => { goTo(0, false); startAutoplay(); });
      document.addEventListener('shopify:block:select', () => { goTo(0, false); stopAutoplay(); });
    });
  })();
  